'use client';
import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const serviceTypes = ['All Services', 'Maid Rental', 'Apartments', 'Hospitality', 'Manager Contact'];

export default function HeroSearchBar() {
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState('All Services');

  return (
    <div className="bg-white rounded-xl shadow-modal p-2 flex flex-col sm:flex-row gap-2">
      <div className="flex items-center gap-2 px-3 py-2 bg-muted rounded-lg flex-1">
        <Icon name="MagnifyingGlassIcon" size={18} className="text-muted-foreground flex-shrink-0" />
        <input
          type="text"
          placeholder="Search maids, apartments, services..."
          value={query}
          onChange={(e) => setQuery(e?.target?.value)}
          className="bg-transparent text-sm text-foreground placeholder:text-muted-foreground outline-none w-full font-body"
          suppressHydrationWarning
        />
      </div>
      <select
        value={selected}
        onChange={(e) => setSelected(e?.target?.value)}
        className="px-3 py-2 bg-muted rounded-lg text-sm text-foreground outline-none font-body cursor-pointer"
        suppressHydrationWarning
      >
        {serviceTypes?.map((s) => (
          <option key={`search-type-${s}`} value={s}>{s}</option>
        ))}
      </select>
      <button className="px-5 py-2 bg-primary text-white text-sm font-semibold rounded-lg hover:bg-primary-light transition-all duration-150 active:scale-95 flex items-center gap-2">
        <Icon name="MagnifyingGlassIcon" size={16} />
        Search
      </button>
    </div>
  );
}